
define('template!headerChatView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="content" title="' +
((__t = ( _.i18n('common.chats') )) == null ? '' : __t) +
'">\n  <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.2 - comment --><path d="M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"/></svg>\n  <div class="badges">\n    <span class="count count-unassigned" title="' +
((__t = ( _.i18n('chat.header.unassigned') )) == null ? '' : __t) +
'"></span>\n    <span class="count count-mine" title="' +
((__t = ( _.i18n('chat.header.mine') )) == null ? '' : __t) +
'"></span>\n  </div>\n  <span class="mute-toggle" title="' +
((__t = ( _.i18n('chat.header.sound') )) == null ? '' : __t) +
'">\n    <svg viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.2 - volume-low --><path d="M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 285.9 400 271.8 400 256s-6.9-29.9-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"/></svg>\n  </span>\n</div>\n';

}
return __p
};});

